"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var SubscribtionConfirm_component_1 = require("./../../../SubscriptionConfirm/SubscribtionConfirm.component");
var SubscribtionConfirmComponent = /** @class */ (function (_super) {
    __extends(SubscribtionConfirmComponent, _super);
    function SubscribtionConfirmComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SubscribtionConfirmComponent;
}(SubscribtionConfirm_component_1.SubscribtionConfirmComponent));
exports.SubscribtionConfirmComponent = SubscribtionConfirmComponent;
